var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dy-dialog",
    {
      attrs: {
        width: "70%",
        title: "选择客户",
        "confirm-title": "确定",
        "show-confirm": _vm.multiple
          ? !!_vm.selectRows.length
          : !!_vm.selectRow,
      },
      on: { onConfirm: _vm.handleSelected, onClose: _vm.handleClose },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("dy-main-container", {
        staticClass: "select-asset-dialog",
        attrs: { "hide-top-menu": "", "hide-left-aside": "" },
        scopedSlots: _vm._u([
          {
            key: "right",
            fn: function () {
              return [
                _c("avue-crud", {
                  ref: "crud",
                  attrs: {
                    page: _vm.page,
                    search: _vm.searchForm,
                    data: _vm.tableList,
                    "table-loading": _vm.tableLoading,
                    option: _vm.crudOption,
                  },
                  on: {
                    "update:page": function ($event) {
                      _vm.page = $event
                    },
                    "update:search": function ($event) {
                      _vm.searchForm = $event
                    },
                    "on-load": _vm.getList,
                    "search-change": _vm.searchChange,
                    "row-click": _vm.rowClick,
                    "selection-change": _vm.selectionChange,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "radio",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: row.$index },
                              model: {
                                value: _vm.selectRowIndex,
                                callback: function ($$v) {
                                  _vm.selectRowIndex = $$v
                                },
                                expression: "selectRowIndex",
                              },
                            },
                            [_vm._v(" ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }